import {type VariantProps} from 'class-variance-authority';
import {Check, X} from 'lucide-react';
import {Checkbox as CheckboxPrimitive} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {checkboxVariants} from './checkbox-variants';

export interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
    VariantProps<typeof checkboxVariants> {}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({className, touchOptimized, variant, ...props}, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxVariants({variant, touchOptimized, className}))}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      {variant === 'rejected' ? (
        <X className="size-4" />
      ) : (
        <Check className="size-4" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export {Checkbox};
